import script from "./user-table-view.vue?vue&type=script&setup=true&lang=js"
export * from "./user-table-view.vue?vue&type=script&setup=true&lang=js"

import "./user-table-view.vue?vue&type=style&index=0&id=2217a14a&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2217a14a"]])

export default __exports__